import React from 'react';
import * as FiIcons from 'react-icons/fi';

const { FiSearch, FiAward, FiTrendingUp, FiMessageCircle, FiShield } = FiIcons;

const steps = [
  { icon: FiSearch, title: 'Advanced Tutor\nScreening', color: 'text-orange-500', ring: 'ring-orange-100', dot: 'bg-orange-400' },
  { icon: FiAward, title: 'Verified Subject\nMastery', color: 'text-purple-500', ring: 'ring-purple-100', dot: 'bg-purple-400' },
  { icon: FiTrendingUp, title: 'Proven Teaching\nExperience', color: 'text-indigo-500', ring: 'ring-indigo-100', dot: 'bg-indigo-400' },
  { icon: FiMessageCircle, title: 'Communication &\nTeaching Skills', color: 'text-blue-500', ring: 'ring-blue-100', dot: 'bg-blue-400' },
  { icon: FiShield, title: '100% Background\nVerified', color: 'text-red-500', ring: 'ring-red-100', dot: 'bg-red-400' }
];

const HowItWorks = () => (
  <section className="py-24 bg-[#fffcfab3]" id="how-it-works">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-20">
        <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 tracking-tight">
          Our Commitment to Quality & Safety <span className="text-4xl">🔥</span>
        </h2>
      </div>

      <div className="relative mt-12">
        {/* Connecting Line Desktop */}
        <div className="hidden md:block absolute top-[7.4rem] left-[10%] right-[10%] h-[3px] bg-gradient-to-r from-orange-200 via-indigo-200 to-red-200 z-0"></div>
        
        <div className="grid grid-cols-2 md:grid-cols-5 gap-y-12 gap-x-2 relative z-10">
          {steps.map((step, idx) => (
            <div key={idx} className="flex flex-col items-center text-center group">
              {/* Icon Ring */}
              <div className={`w-20 h-20 md:w-24 md:h-24 rounded-full bg-white flex items-center justify-center mb-6 ring-[6px] ${step.ring} group-hover:scale-110 transition-transform duration-300 z-10 shadow-sm`}>
                <step.icon className={`w-8 h-8 md:w-10 md:h-10 ${step.color}`} />
              </div>
              
              {/* Timeline Dot */}
              <div className={`hidden md:block w-4 h-4 rounded-full ${step.dot} border-[3px] border-white shadow-sm z-10 mb-5`}></div>
              
              {/* Title */}
              <h3 className="text-sm md:text-[15px] font-bold text-slate-800 whitespace-pre-line leading-tight px-2">
                {step.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default HowItWorks;